/**
 * Site-wide SEO defaults. Override per page via SeoHead.
 * REACT_APP_SITE_URL should be the production origin (no trailing slash).
 */
export const SITE_URL =
  (process.env.REACT_APP_SITE_URL || 'https://buildmate.app').replace(/\/$/, '');

export const SITE_NAME = 'BuildMate';

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const DEFAULT_TWITTER_HANDLE = '@buildmate';

export type SeoPageKey = 'home' | 'about' | 'compare' | 'privacy' | 'terms' | 'cookies' | 'refund';

export const SEO_PATHS: Record<SeoPageKey, string> = {
  home: '/',
  about: '/about',
  compare: '/compare',
  privacy: '/privacy',
  terms: '/terms',
  cookies: '/cookies',
  refund: '/refund',
};

export function absoluteUrl(path: string): string {
  if (!path || path === '/') return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
